import { render, staticRenderFns } from "./chemUpdateHistoryDetail.vue?vue&type=template&id=0fd79997"
import script from "./chemUpdateHistoryDetail.vue?vue&type=script&lang=js"
export * from "./chemUpdateHistoryDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fd79997')) {
      api.createRecord('0fd79997', component.options)
    } else {
      api.reload('0fd79997', component.options)
    }
    module.hot.accept("./chemUpdateHistoryDetail.vue?vue&type=template&id=0fd79997", function () {
      api.rerender('0fd79997', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/form/chemUpdateHistoryDetail.vue"
export default component.exports